/**
 * Created by andrewstirling on 20/6/17.
 */

import React, { Component } from 'react';

export default class CustomerLoginsRow extends Component {
    state = {
        isLoading : true,
        lastSignInTime: null
    }

    componentDidMount = () => {
        this.handleGetUserFromFirebase(this.props.login.username)
    }
    handleResendCode = loginDetails => {
        fetch('/service/resendCode', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin',
            body: JSON.stringify(loginDetails)
        }).then(response => {
            if(response.status === 200) {
                this.props.openModal(loginDetails.email)
            } else {
                response.json().then(error => {
                    this.props.openErrorModal(error.errorMessage)
                })
            }
        }).catch(console.log)
    }

    handleGetUserFromFirebase = username => {
        fetch('/service/firebaseUser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin',
            body: JSON.stringify({username})
        }).then(response => {
            if (response.status === 200) {
                response.json().then(res => {
                    if (res?.metadata) {
                        this.setState({ isLoading: false,  lastSignInTime: res.metadata.lastSignInTime })
                    }

                })
            }
        }).catch(err => console.log(err))
    }

    renderUserActivatedStatus = lastSignInTime => {
        if(!lastSignInTime) {
            return <span className="active-inactive inactive-color" />
        }

        return <span className="active-inactive active-color" />
    }

    render() {
        const { username, firstName, lastName, isAdmin } = this.props.login
        const { isLoading, lastSignInTime } = this.state
        return (
            <tr>
                <td>{username}</td>
                <td>{firstName}</td>
                <td>{lastName}</td>
                <td>{isAdmin && <span className="active-inactive active-color" />}</td>
                <td> {isLoading ? <span className="spinner"/> : this.renderUserActivatedStatus(lastSignInTime)}</td>
                <td> {lastSignInTime
                    && <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => { this.handleResendCode(this.props.login)}}>Resend activation code</button>}
                </td>
            </tr>
        )
    }
}